import { render } from "./ServeCustomersSection.vue?vue&type=template&id=e58bbad2&scoped=true"
import script from "./ServeCustomersSection.vue?vue&type=script&lang=js"
export * from "./ServeCustomersSection.vue?vue&type=script&lang=js"

import "./ServeCustomersSection.vue?vue&type=style&index=0&id=e58bbad2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e58bbad2"]])

export default __exports__